/* eslint-disable no-unused-expressions */
import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { PortalContext } from "../../context/Provider";
import HeaderbarHome from "../../components/Genericos/HeaderbarHome/HeaderbarHome";
import Sidebar from "../../components/Genericos/Sidebar/Sidebar";
import Modal from "../../components/Genericos/Modal/Modal";
import BurguerMobile from "../../components/Genericos/BurguerMobile/BurguerMobile";
import {
  misMedicosResetEncuesta,
  wsGetMisMedicos,
} from "../../context/Actions/misMedicos/misMedicos";
import CardMedico from "../../components/Perfil/CardMedico/CardMedico";
import Dropdown from "../../components/Genericos/Dropdown/Dropdown";
import { multiTabDataMisMedicos } from "../../../global/utils/multiTabData";
import MisMedicosTituloTxt from "./MisMedicosTituloTxt";
import MultitabMobileMisMedicos from "../../components/Turnos/MultitabMobileMisMedicos/MultitabMobileMisMedicos";
import { hideModal, showModal } from "../../context/Actions/modal/modal";
import ToasterV2 from "../../../global/component/Genericos/Toaster/ToasterV2";
import Loading from "../../components/Genericos/Loading/Loading";
import { hideAyuda } from "../../context/Actions/ayuda/ayuda";
import { displayAyuda, displayAyudaMobile } from "../../../global/utils/ayuda";
import { dropdownFamiliares } from "../../components/Turnos/ListaFamiliaresDropdown/ListaFamiliaresDropdown";
import BotonSubir from "../../assets/images/generico/BotonSubir";
import {
  LimpiarSelectGlobal,
  SelectUserGlobal,
} from "../../context/Actions/DropDownFamiliares/selectFamiliares";
import TurnoNoEncontrado from "../../components/Genericos/TurnoNoEcontrado/TurnoNoEncontrado";
import { tokenLogout } from "../../context/Actions/token/logoutToken";
import { showToaster } from "../../../global/context/action/toaster/toaster";
import { GlobalContext } from "../../../global/context/Provider";
import "./MisMedicos.css";
import CardMedicoOLD from "_+_Portal/components/Perfil/CardMedicoOLD/CardMedicoOLD";
import FloatingScroll from "_+_Portal/components/Genericos/FloatingScroll/FloatingScroll";
import { motion } from "framer-motion";
import {
  container,
  dots,
  pageContainerVariants,
} from "global/utils/cardAnimation";
import SelectDropdown from "_+_Portal/components/Genericos/SelectDropdown/SelectDropdown";
import { isMobile } from "react-device-detect";
import { IoFilterOutline, IoChevronDown } from "react-icons/io5";
import HeaderTitle from "_+_Portal/components/Genericos/HeaderTitle/HeaderTitle";

const MisMedicos = () => {
  const {
    modalState,
    modalDispatch,
    misMedicosState,
    misMedicosDispatch,
    ayudaDispatch,
    listaFamiliaresState,
    tokenState,
    tokenDispatch,
    selectDropDownState,
    selectDropDownDispatch,
    textosState,
  } = useContext(PortalContext);

  // Nuevo contexto
  const { authState, toasterState, toasterDispatch, configState } =
    useContext(GlobalContext);

  const history = useHistory();
  const [showBurguerMobile, setShowBurguerMobile] = useState(false);
  const [filtroEspecialidad, setFiltroEspecialidad] = useState(
    multiTabDataMisMedicos[0],
  );
  const [misMedicosFiltrado, setMisMedicosFiltrado] = useState(null);
  const [flgBtnFiltro, setFlgBtnFiltro] = useState(true);

  let familiarId =
    selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id;
  const widthWindow = window.innerWidth;
  const esMobile = widthWindow <= 768;

  const showModalCalificacion = (e) => {
    modalCalificacion(e);
  };

  const onShowBurguerHandle = () => {
    setShowBurguerMobile(true);
  };

  const onCloseBurguerMobile = (type) => {
    if (type === "open") setShowBurguerMobile(true);
    else setShowBurguerMobile(false);
  };

  //aca comienzo los propios de esta pantalla.
  const onChangePaciente = (e) => {
    if (e !== "") {
      if (e.id && e.familiar && e.verResultados) {
        // setUserSelect(e.id);
        wsGetMisMedicos(e.id, true, cargarEstudios)(misMedicosDispatch);
        setFiltroEspecialidad(0);
        SelectUserGlobal({ id: e.id, paciente: e.paciente })(
          selectDropDownDispatch,
        );
        setFlgBtnFiltro(true);
      } else if (!e.familiar) {
        wsGetMisMedicos(-1, true, cargarEstudios)(misMedicosDispatch);
        setFiltroEspecialidad(0);
        LimpiarSelectGlobal()(selectDropDownDispatch);
        setFlgBtnFiltro(true);
      } else if (!e.verResultados && e.familiar) {
        showModal(
          "Perfil/ModalAlertGrupoFamiliar/ModalAlertGrupoFamiliar",
          {},
          "centro",
        )(modalDispatch);
        // setUserSelect(authState.auth.data.paciente.codigo);
        wsGetMisMedicos(-1, true, cargarEstudios)(misMedicosDispatch);
        setFiltroEspecialidad(0);
        LimpiarSelectGlobal()(selectDropDownDispatch);
        setFlgBtnFiltro(true);
      } else {
        // setUserSelect(authState.auth.data.paciente.codigo);
        wsGetMisMedicos(-1, true, cargarEstudios)(misMedicosDispatch);
        setFiltroEspecialidad(0);
        setFlgBtnFiltro(true);
      }
    }
  };

  const onClickBuscarTurnos = () => {
    if (configState.config.data.opcBuscadorTurnos && widthWindow > 1024) {
      history.push("/buscadorTurnos");
    } else {
      history.push("/consultamedica");
    }
  };

  const onChangeFiltro = (e) => {
    if (e.id !== undefined) {
      switch (e.id) {
        case 0:
          setMisMedicosFiltrado(misMedicosState.misMedicos.data);
          setFiltroEspecialidad(e);
          break;
        case 1:
          setMisMedicosFiltrado(
            misMedicosState.misMedicos.data.filter(
              (item) => item.idEspecialidad !== null,
            ),
          );
          setFiltroEspecialidad(e);
          break;
        case 2:
          setMisMedicosFiltrado(
            misMedicosState.misMedicos.data.filter(
              (item) => item.idProtocolo > 0,
            ),
          );
          setFiltroEspecialidad(e);
          break;
        case 3:
          setMisMedicosFiltrado(
            misMedicosState.misMedicos.data.filter(
              (item) => item.encuesta !== null,
            ),
          );
          setFiltroEspecialidad(e);
          break;
        case 4:
          setMisMedicosFiltrado(
            misMedicosState.misMedicos.data.filter(
              (item) => item.encuesta === null,
            ),
          );
          setFiltroEspecialidad(e);
          break;
        default:
          setMisMedicosFiltrado(misMedicosState.misMedicos.data);
          setFiltroEspecialidad(multiTabDataMisMedicos[0]);
      }
    }
  };

  const cargarEstudios = (isCorrect, data) => {
    if (isCorrect) {
      let filteredData = null;
      if (filtroEspecialidad.id === 1) {
        filteredData = data.filter((item) => item.idEspecialidad !== null);
      } else if (filtroEspecialidad.id === 2) {
        filteredData = data.filter((item) => item.idProtocolo > 0);
      } else if (filtroEspecialidad.id === 3) {
        filteredData = data.filter((item) => item.encuesta !== null);
      } else if (filtroEspecialidad.id === 4) {
        filteredData = data.filter((item) => item.encuesta === null);
      } else {
        filteredData = data;
      }
      setMisMedicosFiltrado(filteredData);
    } else {
      showToaster(
        {
          texto: data ? data : "Error al cargar estudios",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
    }
  };

  const traerEstudios = () => {
    if (!selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
      wsGetMisMedicos(-1, false, cargarEstudios)(misMedicosDispatch);
      setFlgBtnFiltro(false);
      setFiltroEspecialidad(0);
    } else {
      wsGetMisMedicos(
        selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id,
        false,
        cargarEstudios,
      )(misMedicosDispatch);
      setFlgBtnFiltro(false);
      setFiltroEspecialidad(0);
    }
  };

  const recargarEstudios = () => {
    if (familiarId === undefined) {
      if (flgBtnFiltro) {
        wsGetMisMedicos(-1, true, cargarEstudios)(misMedicosDispatch);
      } else if (!flgBtnFiltro) {
        wsGetMisMedicos(-1, false, cargarEstudios)(misMedicosDispatch);
      }
      setFiltroEspecialidad(0);
    } else {
      if (flgBtnFiltro) {
        wsGetMisMedicos(familiarId, true, cargarEstudios)(misMedicosDispatch);
      } else if (!flgBtnFiltro) {
        wsGetMisMedicos(familiarId, false, cargarEstudios)(misMedicosDispatch);
      }
      setFiltroEspecialidad(0);
    }
  };

  const dissmiss = () => {
    tokenLogout()(tokenDispatch);
    hideModal()(modalDispatch);
    window.location.reload(false);
  };

  const handleOpenModalFiltro = () => {
    showModal(
      "Genericos/ModalSeleccionarFiltro/ModalSeleccionarFiltro",
      {
        filtros: multiTabDataMisMedicos,
        onSelectFiltro: onChangeFiltro,
        filtroActual: filtroEspecialidad,
      },
      [],
      "bottomSheet",
      false,
    )(modalDispatch);
  };

  const modalCalificacion = (e) => {
    showModal(
      "Genericos/CalificarMisMedicos/CalificarMisMedicos",
      {
        titulo: "¿Cómo fue su experiencia en su atención médica?",
        item: e,
        estrellas_medico_actual:
          e.encuesta !== null ? e.encuesta.estrellas_medico : 0,
        estrellas_recepcion_actual:
          e.encuesta !== null ? e.encuesta.estrellas_recepcion : 0,
        estrellas_tecnico_actual:
          e.encuesta !== null ? e.encuesta.estrellas_tecnico : 0,
        detalle_recepcion_actual:
          e.encuesta !== null ? e.encuesta.detalles_recepcion : "",
        detalle_medico_actual:
          e.encuesta !== null ? e.encuesta.detalles_medico : "",
        detalles_tecnico_actual:
          e.encuesta !== null ? e.encuesta.detalles_tecnico : "",
        dissmiss: dissmiss,
        recargarEstudios: recargarEstudios,
        flgEncuestaToken: false,
      },
      [],
      "centro",
    )(modalDispatch);
  };

  useEffect(() => {
    if (!selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
      wsGetMisMedicos(-1, true, cargarEstudios)(misMedicosDispatch);
    } else {
      wsGetMisMedicos(familiarId, true, cargarEstudios)(misMedicosDispatch);
    }
    setTimeout(() => {
      hideAyuda()(ayudaDispatch);
      displayAyuda("hidden");
      displayAyudaMobile("hidden");
    }, 250);
    // setUserSelect(authState.auth.data.paciente.codigo);
  }, []);

  // abre modal de encuesta con link enviado al mail
  useEffect(() => {
    if (tokenState.token.data && misMedicosState.misMedicos.data) {
      // si es de labo filtro x protocolo
      if (tokenState.token.data.encuesta.idprotocolo > 0) {
        const turnoFiltrado = misMedicosState.misMedicos.data.filter(
          (item) =>
            item.idProtocolo === tokenState.token.data.encuesta[0].idprotocolo,
        );
        if (turnoFiltrado.length > 0) {
          showModalCalificacion(turnoFiltrado[0]);
        }
      } else {
        // si es turno filtro x idTurno
        const turnoFiltrado = misMedicosState.misMedicos.data.filter(
          (item) => item.idTurno === tokenState.token.data.encuesta[0].idturno,
        );
        if (turnoFiltrado.length > 0) {
          showModalCalificacion(turnoFiltrado[0]);
        }
      }
    }
    //eslint-disable-next-line
  }, [tokenState.token.data, misMedicosState.misMedicos.data]);

  return (
    <React.Fragment>
      {modalState.modal.show && <Modal />}
      {toasterState.toaster.show && <ToasterV2 />}
      <Loading
        dataLoading={misMedicosState.misMedicos.loading}
        color="c-white"
        descripcion="Cargando Medicos..."
      />
      {/* HEADER BAR DE PORTAL  */}
      <BurguerMobile
        onCloseBurguerMobile={onCloseBurguerMobile}
        showBurguerMobile={showBurguerMobile}
      />
      <HeaderbarHome onShowBurguerHandle={onShowBurguerHandle} />
      <HeaderTitle title={"Mis Médicos"} />

      <div className="ptur-bodyContainer-misMedicos">
        <div className="ptur-mainSidebar">
          <Sidebar />
        </div>
        <motion.div
          variants={pageContainerVariants(esMobile)}
          initial="hidden"
          animate="visible"
          exit="exit"
          className={"mismed-body-misMedicos"}
        >
          <div className="ptur-misMedicos-tituloLabo rb24b">
            <MisMedicosTituloTxt />
            <div className="ptur-misMedicos-dropdown-boton-container">
              <SelectDropdown
                data={multiTabDataMisMedicos}
                descripcion={"nombre"}
                placeholder={"Seleccionar Filtro"}
                onChangeInput={onChangeFiltro}
                selectedValue={filtroEspecialidad}
                styles={{
                  width: isMobile ? "170px" : "250px",
                }}
              />
              <SelectDropdown
                data={dropdownFamiliares(
                  listaFamiliaresState,
                  authState,
                  "VerResultados",
                )}
                descripcion={"nombre"}
                placeholder={"Seleccionar Familiar"}
                onChangeInput={onChangePaciente}
                selectedValue={
                  selectDropDownState.selectDropDown.selectGlobal
                    .pacienteElegido
                    ? selectDropDownState.selectDropDown.selectGlobal
                        .pacienteElegido.paciente
                    : authState.auth.data.paciente
                }
                styles={{
                  width: isMobile ? "170px" : "250px",
                }}
              />
            </div>
            <hr className="ptur-misMedicos-lineaSeparadora" />
          </div>
          <MultitabMobileMisMedicos
            especialistas={filtroEspecialidad}
            onChangeFiltro={onChangeFiltro}
            onChangePaciente={onChangePaciente}
            datosFamiliares={dropdownFamiliares(
              listaFamiliaresState,
              authState,
              "VerResultados",
            )}
            userSelect={
              selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
                ? familiarId
                : authState.auth.data.paciente.codigo
            }
          />
          <div className="ptur-misMedicos-filtro-container">
            <button
              className="ptur-misMedicos-filtro-btn"
              onClick={handleOpenModalFiltro}
            >
              <IoFilterOutline size={20} />
              <span>{filtroEspecialidad?.nombre || "Todos"}</span>
              <IoChevronDown size={18} />
            </button>
          </div>
          {misMedicosState.misMedicos?.data?.length <= 0 && (
            <div className="ptur-misMedicos-noEcontrado">
              <TurnoNoEncontrado
                state={misMedicosState.misMedicos?.data}
                loadingState={misMedicosState.misMedicos}
                texto={textosState.textos.data?.ofrecerBusqueda?.nombre}
                recomendacion={
                  textosState.textos.data?.ofrecerBusqueda?.descripcion
                }
                txtBtn="Buscar un turno"
                onClickTurnos={onClickBuscarTurnos}
                showBtn={true}
              />
            </div>
          )}

          <motion.ul
            key={misMedicosFiltrado?.length}
            className="ptur-misMedicos-cards"
            variants={container(0.1)}
            initial="hidden"
            animate="visible"
          >
            {Array.isArray(misMedicosFiltrado) &&
              !misMedicosState.misMedicos.loading &&
              misMedicosFiltrado.map((item, index) => (
                <motion.li
                  key={index}
                  className="itemCardMedicos"
                  variants={dots()}
                >
                  <div className="ptur-misMedicos-body">
                    <CardMedico
                      item={item}
                      onClickModal={() => showModalCalificacion(item)}
                    />
                  </div>
                </motion.li>
              ))}
          </motion.ul>
          {misMedicosState.misMedicos.loading ? (
            ""
          ) : (
            // <div className="ptur-misMedicos-botonSubir">
            //   <BotonSubir body={"mismed-body-misMedicos"} />
            // </div>
            <FloatingScroll body={"mismed-body-misMedicos"} />
          )}
        </motion.div>
      </div>
    </React.Fragment>
  );
};
export default MisMedicos;
